/**
 * Color helpers, copied from https://github.com/iconik-io/unified_player
 *
 * TODO: consolidate with other utils when UAD is added to the Iconik monorepo
 */

import type { IconColor } from '../components/icon/icon';

export const hexToRgb = (hex: string): { r: number; g: number; b: number } => {
  const bigint = parseInt(hex.slice(1), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return { r, g, b };
};

export const calculateLuminance = (r: number, g: number, b: number): number => {
  const a = [r, g, b].map((value) => {
    const v = value / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
};

export const randomHexColorCode = (): string => {
  const n = (Math.random() * 0xfffff * 1000000).toString(16);
  return '#' + n.slice(0, 6);
};

export const cssVarToIconColorProp = (
  cssVar?: string,
): IconColor | undefined => {
  switch (cssVar) {
    case 'var(--color-palette-primary-green)':
      return 'primary_green';
    case 'var(--color-palette-primary-pink)':
      return 'primary_pink';
    case 'var(--color-palette-primary-teal)':
      return 'primary_teal';
    case 'var(--color-palette-primary-yellow)':
      return 'primary_yellow';
    case 'var(--color-palette-primary-purple)':
      return 'primary_purple';
    case 'var(--color-palette-primary-label)':
      return 'primary_label';
    case 'var(--color-palette-primary-orange)':
      return 'primary_orange';
    case 'var(--color-palette-primary-blue)':
      return 'primary_blue';
    case 'var(--color-palette-primary-red)':
      return 'primary_red';
    case 'var(--color-palette-primary-inverted)':
      return 'primary_inverted';
    case 'var(--color-palette-primary-turquoise)':
      return 'primary_turquoise';
    case 'var(--color-palette-primary-indigo)':
      return 'primary_indigo';
    case 'var(--color-palette-primary-lilac)':
      return 'primary_lilac';
    case 'var(--color-palette-primary-neutral)':
      return 'primary_neutral';
    case 'var(--color-palette-secondary-label)':
      return 'secondary_label';
    case 'var(--color-palette-secondary-pink)':
      return 'secondary_pink';
    case 'var(--color-palette-secondary-red)':
      return 'secondary_red';
    case 'var(--color-palette-secondary-orange)':
      return 'secondary_orange';
    case 'var(--color-palette-secondary-yellow)':
      return 'secondary_yellow';
    case 'var(--color-palette-secondary-green)':
      return 'secondary_green';
    case 'var(--color-palette-secondary-turquoise)':
      return 'secondary_turquoise';
    case 'var(--color-palette-secondary-teal)':
      return 'secondary_teal';
    case 'var(--color-palette-secondary-blue)':
      return 'secondary_blue';
    case 'var(--color-palette-secondary-indigo)':
      return 'secondary_indigo';
    case 'var(--color-palette-secondary-purple)':
      return 'secondary_purple';
    case 'var(--color-palette-secondary-lilac)':
      return 'secondary_lilac';
    case 'var(--color-palette-secondary-neutral)':
      return 'secondary_neutral';
    case 'var(--color-palette-secondary-inverted)':
      return 'secondary_inverted';
    default:
      return undefined;
  }
};
